define('components/charts/common',['google_charts!corechart'], function() {
    var chartsCommon = {
        /** Common formatters.
        Usage example:
                chartsCommon.dollarsFormat.formatValue(2) // '$2.00'
        **/
        dollarsFormat: new google.visualization.NumberFormat({fractionDigits:2, prefix:'$', negativeParens:true}),
        decimalFormat: new google.visualization.NumberFormat({fractionDigits:2}),
        percentageFormat: new google.visualization.NumberFormat({fractionDigits:2, suffix:'%'}),
        shortDateFormat: new google.visualization.DateFormat({pattern: 'M/d/yyyy', timeZone:0}),
        mediumDateFormat: new google.visualization.DateFormat({pattern: 'MMM d, yyyy', timeZone:0}),

        currencyFormat: {
            'usd': new google.visualization.NumberFormat({fractionDigits:2, prefix:'$', negativeParens:true}),
            'eur': new google.visualization.NumberFormat({fractionDigits:2, prefix:'€', negativeParens:true}),
            'jpy': new google.visualization.NumberFormat({fractionDigits:2, prefix:'¥', negativeParens:true}),
            'gbp': new google.visualization.NumberFormat({fractionDigits:2, prefix:'£', negativeParens:true}),
            'aud': new google.visualization.NumberFormat({fractionDigits:2, prefix:'$', negativeParens:true}),
            'cad': new google.visualization.NumberFormat({fractionDigits:2, prefix:'$', negativeParens:true}),
            'chf': new google.visualization.NumberFormat({fractionDigits:2, prefix:'CHF', negativeParens:true}),
        },

        fontName: 'Moderat, Helvetica, Arial, sans-serif',

//PIE - ['#65AADB','#FFC43D','#F67A7A','#357CB7','#5DB75D'],
//LINE AREA & BAR - ['#65AADB','#5DB75D'],
        colors: {
            commitment: '#337ab7',
            contribution: '#65AADB',
            contributionStroke: '#4390C7',
            contributionCommitment: '#d9edf7',
            contributionCommitmentStroke: '#bce8f1',
            distribution: '#5db75d',
            distributionStroke: '#4cae4c',
            redemption: '#7dc57d',
            redemptionStroke: '#4faf4f',
            distributionBalance: '#dff0d8',
            distributionBalanceStroke: '#d6e9c6',
            rollover: '#8eb9da',
            rolloverStroke: '#85c0de',

/*            contribution: '#337ab7',
            contributionStroke: '#2e6da4',
            contributionCommitment: '#d9edf7',
            contributionCommitmentStroke: '#bce8f1',
            distribution: '#5cb85c',
            distributionStroke: '#4cae4c',
            distributionBalance: '#dff0d8',
            distributionBalanceStroke: '#d6e9c6',
            accountBalance: 'purple',
*/
            piechartPalette: [
                '#65AADB','#FFC43D','#5DB75D','#357CB7','#F67A7A'
            ],
            piechartUnknownColor: '#888888'
        },

        formatCurrency: function(amount, currency) {
            if (typeof(currency) === 'undefined') {
                currency = 'usd';
            }
            var formatter = chartsCommon.currencyFormat[currency] || chartsCommon.currencyFormat.usd;
            return formatter.formatValue(amount);
        }

    };

    return chartsCommon;
});

